import { Container, Button } from 'react-bootstrap';
import ApiKeySection from '../components/ApiKeySection';

function APIkeyMgr() {

  return (
    <Container className="py-5">
      <h2 className="mb-3">MF Schemes exploration for meaningful Recommendation</h2>
      <h4>
        Complementing your Smart Investment decisions in Mutual Funds.
      </h4>
      <ApiKeySection />
    </Container>
  );
}

export default APIkeyMgr;

